import { useState } from 'react';
import { ScrollingColumn } from 'foundations-components/transitional/components/ScrollingColumn';
import { useConditionFieldSelect } from '../../../hooks/useConditionFieldSelect';
import Breadcrumbs from './general/Breadcrumbs';
import FilterFamilySelectOptions from './FilterFamilySelectOptions';
import Search from './general/Search';
import FieldTypeFilterButton from './general/FieldTypeFilterButton';
import FieldTypeFilterBar from './general/FieldTypeFilterBar';
import styled from 'foundations-theming/utils';
import { ObjectTypeIdRegex } from '../../../filterQueryFormat/ObjectTypeId';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SearchGrowContainer = styled.div.withConfig({
  displayName: "FilterFamilySelect__SearchGrowContainer",
  componentId: "sc-8ary9x-0"
})(["flex-grow:1;"]);
const FilterFamilySelect = ({
  filterFamily,
  filterFamilyLabel
}) => {
  const {
    isLoadingFields,
    onSearchChange,
    searchString
  } = useConditionFieldSelect(filterFamily);
  const [localSearchString, setLocalSearchString] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [fieldTypeFilter, setFieldTypeFilter] = useState([]);
  const toggleFieldTypeFilterBar = () => {
    setIsOpen(prevIsOpen => !prevIsOpen);
  };
  return /*#__PURE__*/_jsx(ScrollingColumn, {
    headerContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Breadcrumbs, {
        locationLabel: filterFamilyLabel
      }), /*#__PURE__*/_jsxs(Flex, {
        padding: "400",
        paddingBlockEnd: "200",
        gap: "100",
        children: [/*#__PURE__*/_jsx(SearchGrowContainer, {
          children: /*#__PURE__*/_jsx(Search, {
            onSearchChange: evt => {
              setLocalSearchString(evt.target.value);
              onSearchChange(evt);
            },
            searchPlaceholderAssetLabel: filterFamilyLabel,
            value: localSearchString
          })
        }), /*#__PURE__*/_jsx(FieldTypeFilterButton, {
          disabled: !ObjectTypeIdRegex.test(filterFamily),
          disabledTooltipContent: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.dataExplorer.typeFilter.disabledReason",
            options: {
              assetLabel: filterFamilyLabel
            }
          }),
          filtersCount: fieldTypeFilter.length,
          onClick: toggleFieldTypeFilterBar
        })]
      }), /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: "200",
        paddingInline: "400",
        children: isOpen && /*#__PURE__*/_jsx(FieldTypeFilterBar, {
          onChange: setFieldTypeFilter,
          values: fieldTypeFilter
        })
      })]
    }),
    children: /*#__PURE__*/_jsx(FilterFamilySelectOptions, {
      filterFamily: filterFamily,
      isLoadingFields: isLoadingFields,
      searchString: searchString,
      fieldTypeFilter: fieldTypeFilter
    })
  });
};
export default FilterFamilySelect;